export default __webpack_public_path__ + "c94c20d.png";